import TemplateSurveyState from 'containers/SurveyPage/TemplateSurveyState';
import { transformPropsDeep, escapeHTML } from 'containers/App/utils';
import { find, get } from 'lodash';
import { getAttributeIds } from 'containers/QuestionnairePage/QuestionGroup/utils';
import {
  mapQuestionsAndGroupsAsNodes,
  duplicateQuestion as duplicateQuestionHelper,
} from 'containers/QuestionnairePage/utils';
import { v1 as uuidv1 } from 'uuid';
import { SURVEY_TYPE_PEEQ } from 'containers/Survey/constants';

import { generators } from '../constants';

const conjointMaxDiffTestingGenerator = ({
  template,
  variables,
  surveyType,
}) => {
  // pass the fetchedXXXX options only
  // if you intend to use the relevant template as-is

  const Survey = new TemplateSurveyState({
    // fetchedQuestionnaire: template.questionnaireTemplate,
    fetchedTargeting:
      surveyType === SURVEY_TYPE_PEEQ
        ? template.peeqTargetingTemplate
        : template.regularTargetingTemplate,
  });

  const isMaxDiffType = template.generator === generators.MAXDIFF_TESTING;
  const questionTag = isMaxDiffType ? 'maxdiff_question' : 'conjoint_question';
  const promptRegex = isMaxDiffType
    ? /\{\{maxdiff_question\}\}/gi
    : /\{\{conjoint_question\}\}/gi;

  const conjointQuestion = get(
    find(variables, ['name', questionTag]),
    'value',
    '',
  );
  const replaceConjointQuestion = (value) =>
    value.replace(promptRegex, escapeHTML(conjointQuestion));

  const attributes = get(find(variables, ['name', 'attributes']), 'value', []);

  const questionnaireTemplate = transformPropsDeep(
    template.questionnaireTemplate,
    { prompt: replaceConjointQuestion, htmlPrompt: replaceConjointQuestion },
  );

  const { nodes } = mapQuestionsAndGroupsAsNodes(questionnaireTemplate);

  const conjointGroupNode = duplicateQuestionHelper(nodes[0]);

  Survey.questionnaire.addQuestion(conjointGroupNode);

  // CLEAN UP
  // Remove Concepts and Attributes
  // const conjointConceptIds = getConceptIds(conjointGroupNode);
  const attributesIds = getAttributeIds(conjointGroupNode);

  attributesIds.forEach((attributeId) => {
    Survey.questionnaire.removeGroupAttribute({
      refId: conjointGroupNode.refId,
      attributeRefId: attributeId,
      groupType: conjointGroupNode.type,
    });
  });

  attributes.forEach((attribute) => {
    const generatedAttribute = Survey.questionnaire.addGroupAttribute({
      refId: conjointGroupNode.refId,
      type: attribute.type,
      groupType: conjointGroupNode.type,
    });

    const attributeValues = attribute.values.map((attributeValue) => ({
      refId: uuidv1(),
      ...attributeValue,
    }));

    Survey.questionnaire.updateGroupAttribute({
      refId: conjointGroupNode.refId,
      attributeRefId: generatedAttribute.refId,
      groupType: conjointGroupNode.type,
      values: attributeValues,
      name: attribute.name,
      media: attribute.media,
    });
  });

  return { state: Survey.state };
};

export default conjointMaxDiffTestingGenerator;
